import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import { createSelector } from '@reduxjs/toolkit'

import type { ReduxState } from 'src/store/types'
import { hasTag } from 'utils/gameTags'

const getGames = (state: ReduxState) => state.games

const getGameId = (state: ReduxState, gameId: string) => gameId

export const allGamesSelector = createSelector(getGames, (games) => games.allGames)

export const allVisibleGamesSelector = createSelector(getGames, (games) => games.allGames.filter((it) => !it.hidden))

export const allGamesLoadingSelector = createSelector(getGames, (games) => games.loading)

export const getAllGamesProductsSelector = createSelector(getGames, (games) => {
  if (games.gamesByCategory) {
    return Object.values(games.gamesByCategory).reduce((acc, products) => {
      return acc.concat(products)
    }, [] as GameProduct[])
  }

  return []
})

export const getGamesWithoutLotterySelector = createSelector(getAllGamesProductsSelector, (games) =>
  games.filter((it) => it.type !== 'lottery'),
)

export const getSlotProductsSelector = createSelector(getGames, (games) =>
  games.gamesByCategory?.slots.filter((it) => !!it),
)

export const getNewGamesSelector = createSelector(getAllGamesProductsSelector, (games) =>
  games.filter((it) => hasTag(it.tags, 'new')),
)

export const getTopGamesSelector = createSelector(getAllGamesProductsSelector, (games) =>
  games.filter((it) => hasTag(it.tags, 'top')),
)

const TOP_GAMES_COUNT = 5

export const getFirstTopGames = createSelector(getTopGamesSelector, (games) => {
  const allTopGames = games.filter((it) => hasTag(it.tags, 'top'))

  return [...allTopGames.slice(0, TOP_GAMES_COUNT)]
})

export const getGameByIdSelector = createSelector(getAllGamesProductsSelector, getGameId, (games, gameId: string) => {
  return games?.find((it) => it.code === gameId)
})

export const getUnlockedSlotsGamesSelector = createSelector(getSlotProductsSelector, (slots) => {
  if (slots) {
    return slots.filter((it) => it.unlocked)
  }

  return null
})

export const getFirstUnlockedSlotSelector = createSelector(getSlotProductsSelector, (games) => {
  if (games && games.length > 0) {
    return games[0]
  }

  return null
})

export const getBingoGamesSelector = createSelector(getAllGamesProductsSelector, (allGames) => {
  const bingoGames = allGames.filter((i) => i.type === 'bingo')

  // quik fix for bingo games
  const hardRooms = [{ title: 'hollywood' }, { title: 'empire_state' }]

  return [...(bingoGames || []), ...hardRooms] as GameProduct[]
})
